export enum EmoteStreamType {
  OFFICIAL = 'official',
  COMMUNITY = 'community',
  SEARCH = 'search',
  USER = 'user',
}

export interface EmoteRequestInfo {
  streamType: EmoteStreamType;
  searchQuery: string;
  /**
   * Not sure if we need anything here besides `community`,
   * but matching the previous redux setup for now.
   */
  searchType: 'community' | 'user';
}

export interface EmoteResult {
  id: number;
  type: EmoteStreamType;
  src: string;
  title: string;
  width: number;
  height: number;
}

export interface EmoteStream {
  hasMore: boolean;
  nextOffset?: number;
  results: EmoteResult[];
}

export interface EmoteStoreSlice {
  isLoadingMore: boolean;
  isLoadingStream: boolean;
  activeStream: EmoteStreamType;
  isInitialized: boolean;
  officialEmotes?: EmoteStream;
  communityEmotes?: EmoteStream;
  userEmotes?: EmoteStream;
  searchEmotes?: EmoteStream;
  cachedSearchQuery: string;
  /**
   * Not sure if we need anything here besides `community`,
   * but matching the previous redux setup for now.
   */
  cachedSearchType: 'community' | 'user';
}
